import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-trade-barometer.component.scss';
var FormItemTradeBarometer = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemTradeBarometer, _super);
    function FormItemTradeBarometer(element) {
        return _super.call(this, element) || this;
    }
    FormItemTradeBarometer.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
    };
    FormItemTradeBarometer.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemTradeBarometer.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        // fields
        var postData = "";
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _contact = this.form.querySelector("input[name=contact-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _province = this.form.querySelector("select[name=province]");
        var _popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var _country = form.querySelector("select[name=country]");
        var _serviceType = form.querySelector("input[name=service-type]");
        var email = this.form.querySelector("input[name=email]");
        var recipient = this.form.querySelector("input[name=recipient]");
        var subject = this.form.querySelector("input[name=subject]");
        var _postData = {
            'recipient': (recipient ? recipient.value : ""),
            'subject': (subject ? subject.value : ""),
            'email': (email ? email.value : ""),
            'firstName': (_firstname ? _firstname.value : ""),
            'lastName': (_lastName ? _lastName.value : ""),
            'contactNumber': (_contact ? _contact.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'businessName': (_businessName ? _businessName.value : ""),
            'province': (_province ? _province.value : ""),
            'country': (_country ? _country.value : ""),
            'serviceType': (_serviceType ? _serviceType.value : ""),
            'consent': ((_popiaConsent ? (_popiaConsent.checked ? "YES" : "NO") : "NO"))
        };
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/genericform.jsp";
        var _config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData), _config).then(function (response) {
            loader.classList.remove('active');
            if (!response.data || (response.data.toString().toLowerCase().includes('invalid'))
                || response.data['error'] === 'true') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                thankYou.classList.add('active');
                success.classList.remove('active');
                success.classList.add('hidden');
                error.classList.remove('hidden');
                error.classList.add('active');
            }
            else {
                if (response.code) {
                    analyticsService.dtmFormComplete('complete', response.code);
                }
                else if (response.status) {
                    analyticsService.dtmFormComplete('complete', response.status);
                }
                else {
                    analyticsService.dtmFormComplete('complete', '200');
                }
                thankYou.classList.add('active');
                error.classList.remove('active');
                error.classList.add('hidden');
                success.classList.remove('hidden');
                success.classList.add('active');
            }
        }).catch(function (response) {
            // service failed
            console.log(response);
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    return FormItemTradeBarometer;
}(Base));
export { FormItemTradeBarometer };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-trade-barometer/form-item-trade-barometer.component.ts
// module id = 963
// module chunks = 0